/**
 * The entry point of the build WITH the Control Center — the `*-clarity` configurations point the
 * builder's `browser` option here instead of `main.ts`.
 *
 * The two files differ in one import: the route table, and through it the shell. That is the entire
 * separation between the two applications this project produces, and it is an entry point rather
 * than a flag because a flag cannot remove code — `imports` and module-level imports are resolved
 * statically, so a single graph naming both shells ships both.
 */
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@efficiently/client-core-environment';
import { initClientSentry, suppressConsoleInProduction } from '@efficiently/client-core-observability';

import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { PLATFORM_APP_ROUTES } from './app/platform.routes';

initClientSentry({ app: 'design-schedule', environment });

if (environment.production) {
	enableProdMode();

	// TODO: EFF-10116 - after implementing the project build using ESBuild, remove the consoles from here and fix it in the drop esbuild property
	suppressConsoleInProduction();
}
// Need logic sha384
bootstrapApplication(AppComponent, createAppConfig(PLATFORM_APP_ROUTES)).catch(error => console.error(error));
